'use client'
import { useContext, useEffect } from 'react'
import type { NextPage } from 'next'
import { useRouter } from 'next/navigation'
import AuthContext from '../context/AuthContext'
import { isRegistrationComplete } from '../services/auth'

const Home: NextPage = () => {
	const authContext = useContext(AuthContext)
	const router = useRouter()

	useEffect(() => {
		if (authContext.loggedIn) {
			if (!isRegistrationComplete(authContext.user)) {
				router.replace('/register')
			} else {
				router.replace('/dashboard/members')
			}
		} else {
			router.replace('/login')
		}
	}, [authContext.loggedIn, authContext.user, authContext.loading, router])

	return null
}

export default Home
